import { usePumpSizing } from "../../../context/PumpSizingContext";
import { TdhHelpFields } from "./TdhHelpFields";

export function TdhStandardHelp() {
	const { formData, updateStandardTdh } = usePumpSizing();
	const { standard } = formData.tdhData;

	return (
		<TdhHelpFields
			help={standard}
			onUpdate={updateStandardTdh}
			staticHeadLabel="Static Head (ft)"
		/>
	);
}
